<div id="no-online-booking">
  <img
    src="https://salonmonster.com/images/online-booking.png"
    class="no-online-booking-image"
  />
  <h2>{{ 'APP.BOOKING_DISABLED' | translate }}</h2>
  <h3 *ngIf="salonPhone">{{ 'APP.CONTACT_US_AT' | translate:{ phone: salonPhone } }}</h3>
</div>
